import React, { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { NotificationBell } from './NotificationBell';
import { SidebarTrigger } from "@/components/ui/sidebar";
import { Separator } from "@/components/ui/separator";
import { UserNav } from './UserNav';
import { useNavigate } from 'react-router';
import { NavigationTabs } from './NavigationTabs';

interface HeaderProps {
  onLogout: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onLogout }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const getUserInitials = () => {
    if (user?.fullName) {
      const names = user.fullName.split(' ');
      return names.map(n => n[0]).join('').toUpperCase().slice(0, 2);
    }
    return user?.username?.slice(0, 2).toUpperCase() || 'U';
  };

  return (
    <header className="flex h-14 shrink-0 items-center justify-between gap-2 border-b bg-white px-4 sticky top-0 z-40 transition-all duration-200">
      <div className="flex items-center gap-4 flex-1 overflow-x-auto no-scrollbar">
        <SidebarTrigger className="-ml-1" />
        <Separator orientation="vertical" className="mr-2 h-4 hidden md:block" />
        
        {/* Navigation Tabs (Using reusable component) */}
        <NavigationTabs />
      </div>

      {/* Right side: Notifications + User Menu */}
      <div className="flex items-center gap-3 shrink-0 ml-2">
        {/* Notification Bell */}
        <NotificationBell variant="header" />

        {/* User Dropdown */}
        <UserNav onLogout={onLogout} />
      </div>
    </header>
  );
};
